export {
  ACCOUNT_CONTENT_MAX_WIDTH,
  ACCOUNT_NAV,
  getAccountTitleKeyBySlug,
  default,
} from './AccountLayout';
